<ng-lottie [options]="options" *ngIf="options" />
<ng-content></ng-content>